<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: '404',
  },

  components: { Layout },

  props: {
    resource: {
      type: String,
      default: '',
    },
  },

  methods: {
    homeClick: function() {
      this.$router.push({ name: 'Device State' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">The page you are looking for was not found.</p>
          <b-button class="float-left display-3 mr-4" @click="homeClick">Home</b-button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
